import { formatPurchaseOrderDate } from 'components/procurement/components/purchaseOrdersV2/utils/purchaseOrderDateUtils';

/** @type {string} */
export const FC_TRANSFER_DISPLAY_FALLBACK = '—';

/**
 * Estimated departure date from list or detail payload (`estimatedDepartureDate` per inventory v1).
 *
 * @param {Record<string, unknown> | null | undefined} transferOrRow
 * @returns {unknown}
 */
export function getEstimatedDepartureRaw(transferOrRow) {
    if (!transferOrRow || typeof transferOrRow !== 'object') {
        return undefined;
    }
    return transferOrRow.estimatedDepartureDate ?? transferOrRow.estimated_departure_date;
}

/**
 * @param {Record<string, unknown> | null | undefined} transferOrRow
 * @param {string} [fallbackText]
 * @returns {string}
 */
export function formatFCTransferEstimatedDepartureDisplay(transferOrRow, fallbackText = FC_TRANSFER_DISPLAY_FALLBACK) {
    return formatPurchaseOrderDate(getEstimatedDepartureRaw(transferOrRow), fallbackText);
}

/**
 * Transfer # for UI (`GET …/fc-transfers` list and detail contract uses `id`).
 *
 * @param {Record<string, unknown> | null | undefined} transferOrRow
 * @returns {string | number}
 */
export function getTransferNumberDisplay(transferOrRow) {
    if (!transferOrRow || typeof transferOrRow !== 'object') {
        return FC_TRANSFER_DISPLAY_FALLBACK;
    }
    const { id } = transferOrRow;
    if (id === undefined || id === null || id === '') {
        return FC_TRANSFER_DISPLAY_FALLBACK;
    }
    return id;
}

/**
 * Status label for UI (API contract: `status`).
 *
 * @param {Record<string, unknown> | null | undefined} transferOrRow
 * @returns {string | number}
 */
export function getTransferStatusDisplay(transferOrRow) {
    if (!transferOrRow || typeof transferOrRow !== 'object') {
        return FC_TRANSFER_DISPLAY_FALLBACK;
    }
    const { status } = transferOrRow;
    if (status === undefined || status === null || status === '') {
        return FC_TRANSFER_DISPLAY_FALLBACK;
    }
    return status;
}

/**
 * @param {Record<string, unknown> | null | undefined} transferOrRow
 * @returns {boolean}
 */
export function isFCTransferPendingStatus(transferOrRow) {
    if (!transferOrRow || typeof transferOrRow !== 'object') {
        return false;
    }
    const { status: raw } = transferOrRow;
    if (raw === undefined || raw === null || raw === '') {
        return false;
    }
    return String(raw).toUpperCase() === 'PENDING';
}
